let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dsP7L")).then(() => parcelRequire('6Rg2D'));